// extracted by mini-css-extract-plugin
export default {"wrapper":"base-filter-card_wrapper__fPROh","baseCardFilter":"base-filter-card_baseCardFilter__ScIL9","text":"base-filter-card_text__IrOs+"};